import { Navigate, useLocation, useParams } from "react-router";

// A Grow URL whose name changed keeps its old bookmarks working. The Toleranz power
// changed its genesis element, and with it both its power code (Cop -> Tol) and the
// element name its self-assessment URL carries (COOPERATION -> TOLERANCE),
// @external-adr GENESIS-0064-the-tolerance-power-is-element-tolerance.
//
// `to` is the replacement path, carrying `:questionnaireId` where the retired route
// had one. It is never derived from the current pathname: React Router matches paths
// case-insensitively, so /grow/power/cop lands here too, and rewriting the pathname by
// substring would find nothing and navigate to the URL the page is already on — a
// blank screen rather than a redirect. Query and fragment ride along, as a legacy link
// must keep them (docs/UI_CONVENTIONS.md).
export function RetiredGrowRedirect({ to }: { to: string }) {
  const { search, hash } = useLocation();
  const { questionnaireId } = useParams<{ questionnaireId?: string }>();
  const pathname =
    questionnaireId == null
      ? to
      : to.replace(":questionnaireId", encodeURIComponent(questionnaireId));

  return <Navigate to={{ pathname, search, hash }} replace />;
}
